export default "__VITE_ASSET__b4969683__"